
import SignaturePad from '@/components/campaign/components/SignaturePad';
import StampUpload from '@/components/campaign/components/StampUpload';
import { CompanyRegistrationUpload } from './CompanyRegistrationUpload';
import { VATRegistrationUpload } from './VATRegistrationUpload';

interface DocumentsSectionProps {
  signature: { data: string; type: 'draw' | 'upload' } | null;
  stamp: string | null;
  companyRegistration: File | null;
  vatRegistration: File | null;
  onSignatureSave: (signatureData: string, type: 'draw' | 'upload') => void;
  onStampUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onStampRemove: () => void;
  onCompanyRegistrationUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onVATRegistrationUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const DocumentsSection = ({
  signature,
  stamp,
  companyRegistration,
  vatRegistration,
  onSignatureSave,
  onStampUpload,
  onStampRemove,
  onCompanyRegistrationUpload,
  onVATRegistrationUpload,
}: DocumentsSectionProps) => {
  return (
    <div className="mt-4 space-y-4">
      <div>
        <h3 className="font-semibold mb-2 text-sm">Authorized Signature:</h3>
        <SignaturePad onSave={onSignatureSave} />
      </div>
      
      <StampUpload
        stamp={stamp}
        onStampUpload={onStampUpload}
        onStampRemove={onStampRemove}
      />

      <CompanyRegistrationUpload
        companyRegistration={companyRegistration}
        onUpload={onCompanyRegistrationUpload}
      />

      <VATRegistrationUpload
        vatRegistration={vatRegistration}
        onUpload={onVATRegistrationUpload}
      />
    </div>
  );
};
